import { useStyletron } from 'baseui';
import { PLACEMENT } from 'baseui/tooltip';

import ENGTTooltip from 'components/UI/ENGTTooltip/ENGTTooltip';

import { VOICE_CAMPAIGN_STATUS } from 'shared/enum';
import { getVoiceCampaignDisplayStatus } from 'shared/helpers/campaignHelpers';
import CompletedIcon from 'shared/icons/Broadcast/CompletedIcon';
import ENGTBaseIcon from 'shared/icons/Broadcast/ENGTBaseIcon';
import FailedIcon from 'shared/icons/Broadcast/FailedIcon';
import PreparingIcon from 'shared/icons/Broadcast/PreparingIcon';
import RetryingIcon from 'shared/icons/Broadcast/RetryingIcon';

interface IVoiceCampaignStatus {
	label: string;
	size?: 'default' | 'large';
	status: string;
	statusReason: string;
}

const VoiceCampaignStatus = ({ label, size = 'default', status, statusReason }: IVoiceCampaignStatus) => {
	const [css, theme]: [any, any] = useStyletron();
	const displayStatus = getVoiceCampaignDisplayStatus(status, statusReason);
	const isRunning =
		displayStatus === VOICE_CAMPAIGN_STATUS.RUNNING || displayStatus === VOICE_CAMPAIGN_STATUS.IN_PROGRESS;
	let statusNode = <>{label}</>;

	if (displayStatus === VOICE_CAMPAIGN_STATUS.COMPLETED) {
		statusNode = <CompletedIcon fillColorForText={theme.colors.primaryA} fillColorForImage={theme.completedIcon} />;
	} else if (displayStatus === VOICE_CAMPAIGN_STATUS.FAILED || displayStatus === VOICE_CAMPAIGN_STATUS.EXPIRED) {
		statusNode = <FailedIcon fillColorForText={theme.colors.primaryA} fillColorForImage={theme.failure} />;
	} else if (displayStatus === VOICE_CAMPAIGN_STATUS.PREPARING) {
		statusNode = <PreparingIcon fillColorForText={theme.colors.primaryA} fillColorForImage={theme.preparingIcon} />;
	} else if (displayStatus === VOICE_CAMPAIGN_STATUS.RETRYING) {
		statusNode = <RetryingIcon fillColorForText={theme.colors.primaryA} fillColorForImage={theme.retryingIcon} />;
	} else {
		let statusColor: string | undefined;

		if (displayStatus === VOICE_CAMPAIGN_STATUS.STOPPED || displayStatus === VOICE_CAMPAIGN_STATUS.PAUSED) {
			statusColor = theme.stoppedIcon;
		} else if (isRunning) {
			statusColor = theme.inProgressIcon;
		} else if (
			displayStatus === VOICE_CAMPAIGN_STATUS.DRAFT ||
			displayStatus === VOICE_CAMPAIGN_STATUS.SCHEDULED ||
			displayStatus === VOICE_CAMPAIGN_STATUS.WAITING
		) {
			statusColor = theme.colors.accent50;
		}

		if (statusColor) {
			statusNode = (
				<ENGTBaseIcon fillColorForText={theme.colors.primaryA} fillColorForImage={statusColor} label={label} />
			);
		}
	}
	const sizedStatusNode =
		size === 'large' ? (
			<span
				className={css({
					display: 'inline-flex',
					margin: '0 0.25rem',
					transform: 'scale(1.15)',
					transformOrigin: 'center',
				})}
			>
				{statusNode}
			</span>
		) : (
			statusNode
		);

	if (
		(displayStatus === VOICE_CAMPAIGN_STATUS.FAILED || displayStatus === VOICE_CAMPAIGN_STATUS.WAITING) &&
		statusReason
	) {
		return (
			<ENGTTooltip content={statusReason} placement={PLACEMENT.top}>
				<div className={css({ cursor: 'pointer', display: 'inline-flex' })}>{sizedStatusNode}</div>
			</ENGTTooltip>
		);
	}

	return sizedStatusNode;
};

export default VoiceCampaignStatus;
